import { render } from "./AvatarList.vue?vue&type=template&id=46ddeefe&scoped=true"
import script from "./AvatarList.vue?vue&type=script&lang=js"
export * from "./AvatarList.vue?vue&type=script&lang=js"

import "./AvatarList.vue?vue&type=style&index=0&id=46ddeefe&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ddeefe"]])

export default __exports__